// extracted by mini-css-extract-plugin
export default {"ElearningSectionContainer":"ElearningSection_ElearningSectionContainer__U5Ww6"};